import React from 'react';
import '../styles/InProgressLeadsBadge.css';
import { useCompany } from '../contexts';
import { useInProgressLeadsCount } from '../hooks';

// Self-contained live indicator for leads currently being processed by
// propertyIngestionV2 (status: queued | processing). Drop in anywhere — it
// pulls its own companyId + count and renders null when there's nothing
// in flight.
function InProgressLeadsBadge() {
    const { companyId } = useCompany();
    const count = useInProgressLeadsCount(companyId);

    if (count <= 0) return null;

    return (
        <div className="in-progress-leads-badge bg-colour-jade-01" role="status" aria-live="polite">
            <span className="in-progress-leads-badge-dot" />
            <span className="label-bold colour-jade-03">
                Processing {count} new lead{count === 1 ? '' : 's'}
            </span>
        </div>
    );
}

export default InProgressLeadsBadge;
